"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'agent',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        limit: 20,
        page_num: 1
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == "agentEdit") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    if (!this.$route.meta.isBack || !this.list) {
      this.toQuery(1);
    }
  },
  computed: {
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    }
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) this.form = {};
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/product/sample_list';
      var listQuery = Object.assign(this.form, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.list_table.$el.offsetTop - 80;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};